import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { Box, Grid, styled } from '@mui/material';
import { BasicAlert } from '@ngt/openiddict';
import React, { FunctionComponent, isValidElement, PropsWithChildren } from 'react';


interface IIconCardListProps {
}

const Cards = styled(Box)(({theme}) => ({
    padding: theme.spacing(3, 0)
}))

const IconCardList: FunctionComponent<PropsWithChildren<IIconCardListProps>> = ({
    children
}) => {
    if (!isValidElement(children) && !(children instanceof Array)) {
        return (
            <Cards>
                <BasicAlert
                    icon={faExclamationTriangle}
                    severity="error"
                    title="No Cards"
                    description={`No cards were provided to the administration card list.`}
                />
            </Cards>
        );
    }

    return (
        <Cards>
            <Grid container spacing={3}>
                {children}
            </Grid>
        </Cards>
    )
};

export default IconCardList;